import { useMutation } from '@tanstack/react-query';
import { ICoffeeLeadIssueFilter, ISystemJob } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export const useCoffeeLeadIssueExportMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: any) => void;
	onSuccess?: (data: ISystemJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (filter: ICoffeeLeadIssueFilter) => {
			return userSession.webServiceHelper.callAsync<ISystemJob>('coffeeleadissue/export', 'POST', filter);
		},
		onError,
		onSuccess,
	});
};
